import React, { useEffect, useState } from 'react'
import MUIDataTable from "mui-datatables";
import styled from '@emotion/styled';
import { CacheProvider } from "@emotion/react";
import createCache from "@emotion/cache";
import useAuth from '../../../hooks/useAuth';
import useAxiosPrivate from '../../../hooks/useAxiosPrivate';

const muiCache = createCache({
	"key": "mui",
	"prepend": true
});




const StyledMUIDataTable=styled(MUIDataTable)(({theme})=>({
  background:theme.palette.background.default,
  height:'100%',
  marginBottom: '30px',
  // '& .css-1nrlq1o-MuiFormControl-root':{
  //      padding:'16px 24px',
  // },
  // '& .css-1w1rijm-MuiButtonBase-root-MuiButton-root':{
  //   padding:'0px'
  // },
  // '& .css-1v17xvx-MuiTableCell-root':{
  //   padding:'0px',
  //   marginLeft:'-15px',
  // },
  // '& .css-10ud224-MuiTableCell-root':{
  //   padding:'0px'
  // },
  // '& .css-nfmglb-MuiTableCell-root':{
  //   padding:'0px'
  // },
  //  '& .tss-1vsygk-MUIDataTableFilterList-root':{
  //   gap:'8px',

  // },
}))
export default function PaymentRate(props) {
    const columns = [
 {
  name: "rank",
  label: "Academic Rank",
  options: {
   filter: true,
   sort: true,
  }
 },
 {
  name: "lec_rate",
  label: "Rate of Payment(Birr/Hour)",
  options: {
   filter: false,
   sort: true,
  }
 },
]
 return(
  <CacheProvider value={muiCache}>
  <StyledMUIDataTable
  title={props.title}
  data={props.data}
  columns={columns}
  options={props.options}
/></CacheProvider>
 )} 